import Text3 from './Text3'
export default Text3
